<div class="d-flex justify-content-between">
  <!-- Recert Button -->
  @if (recertBtnVisible) {
    <button
      type="button"
      class="btn btn-outline-warning btn-sm ag_grid_row_btn form-control py-0"
      style="margin-left: 2px; margin-right: 2px"
      placement="left"
      (click)="recertClick()"
      >
      <i class="fa-solid fa-pen"></i> Re-cert Needed
    </button>
  }
</div>
